module.exports = __webpack_public_path__ + "static/assets/f565e92aee804a9985403ac0d37ed37a.png";